<template>
  <div>
    <!-- <div class="popup-modal" v-if="holidayShow">
      <img alt="" :src="gifUrl" alt="holiday" class="popup-img">
      <span class="pop-holiday-close" @click="closeHolidayPop"></span>
    </div> -->
    <div style="height: 520px">
      <swiper
        :options="swiperOption"
        ref="mySwiper"
        v-if="swiperSlides.length"
        @someSwiperEvent="callback"
        class="banner-view"
      >
        <swiper-slide
          v-for="(banner, index) in swiperSlides"
          :key="index"
          class="each-banner"
        >
          <div
            class="banner-middle"
            :style="{ backgroundImage: 'url(' + banner.picUrl + ')' }"
          >
            <div class="banner-content-middle">
              <div class="banner-content">
                <div v-if="false" class="banner-title">
                  {{ banner.title }}
                </div>
                <div v-if="false" class="banner-txt">
                  {{ banner.content }}
                </div>
                <div
                  v-if="banner.content"
                  class="banner-btn"
                  @click="learnMore1(banner.content)"
                >
                  {{ $t("headerMenu.findDetail") }}
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="protal-person">
      <div class="main-news" v-if="roleVal">
        <div class="news-label">经销商人才发展报告</div>
        <div class="dash-div">
          <iframe
            width="1200"
            height="770"
            frameborder="0"
            border="0"
            title=""
            src="https://joylearning.bmw.com.cn/report/?ssoAuthenticated=true&activeAuth=oauth2&reloadUser=true#/private/share/app/E83D917D26E7FED41B016C27D4B6B5A54?header=false&chartAccessible=false"
          ></iframe>
        </div>
      </div>
    </div>
    <div class="html5-div" v-if="schoolWord">
      <iframe
        id="bdIframe"
        :src="schoolWord.paramValue"
        ref="framePage"
        width="100%"
        :style="{ height: schoolWord.remark + 'px' }"
        frameborder="0"
        border="0"
        scrolling="no"
        title=""
      ></iframe>
    </div>
    <!--    <div class="main-news">-->
    <!--      <div class="news-title">-->
    <!--        <div class="news-more"-->
    <!--             @click="showMore()">-->
    <!--          更多-->
    <!--        </div>-->
    <!--        新闻-->
    <!--      </div>-->
    <!--      <div class="news-swiper">-->
    <!--        <swiper :options="swiperNewsOption"-->
    <!--                ref="mySwiper"-->
    <!--                @someSwiperEvent="callback"-->
    <!--                class="news-view">-->
    <!--          <swiper-slide v-for="(banner,index) in swiperNews"-->
    <!--                        :key="index"-->
    <!--                        class="each-banner">-->
    <!--            <div class="news-overflow"-->
    <!--                 v-for="(item,index) in banner.banner"-->
    <!--                 :key="index"-->
    <!--                 @click="goDetail(item.id)">-->
    <!--              <div class="news-index">-->
    <!--                {{item.index}}-->
    <!--              </div>-->
    <!--              <div class="news-desc">-->
    <!--                {{item.contentTitle}}-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </swiper-slide>-->
    <!--          <div class="swiper-news-pagination"-->
    <!--               slot="pagination"></div>-->
    <!--        </swiper>-->
    <!--      </div>-->
    <!--    </div>-->

    <div id="oauthForm" style="display: none">
      <form
        id="oauth_form"
        method="post"
        target="oauth_target"
        action="https://testjoylearning.bmw.com.cn/oauth2/login"
      >
        <input id="oauth_username" type="text" name="username" value="" />
        <input id="oauth_password" type="text" name="password" value="" />
      </form>
      <iframe width="0" height="0" name="oauth_target" title=""></iframe>
    </div>

    <div class="bmw-float-btn" v-show="false">
      <div class="box-btns">
        <div class="table-box"></div>
        <div class="circle-box">
          <a :href="urlHead + '/html/site.html'" target="_blank">
            <div class="circle-text">培训场地</div>
          </a>
        </div>
      </div>
      <div class="box-btns">
        <div class="table-box"></div>
        <div class="circle-box">
          <a :href="urlHead + '/html/paper.html'" target="_blank">
            <div class="circle-text">联系我们</div>
          </a>
        </div>
      </div>
      <div id="oauth2js" style="display: none"></div>
    </div>

    <iframe
      name="loginAdminIFrame"
      id="loginAdminIFrame"
      src="javascript:void(0)"
      width="0"
      height="0"
      frameborder="0"
      title=""
    >
    </iframe>
    <form
      action="#"
      method="post"
      target="loginAdminIFrame"
      name="adminLoginForm"
      id="adminLoginForm"
      enctype="application/x-www-form-urlencoded"
    >
      <input type="hidden" id="loginAdminToken" name="access_token" value="" />
    </form>

<!-- 隐私协议弹窗 -->
    <el-dialog
      title="用户注册协议和隐私条款"
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width=450px
      center>

      <span >为了更好地保障您的合法权益，请您阅读并同意以下协议《<span style="color:blue;cursor : pointer;" @click="showAgreement">{{ $t('protaRegister.agreement') }}</span>》
      <!-- 隐私协议    t.protaRegister.messageProtection= '个人信息保护'-->

      <span v-show="this.tenantId===1||this.tenantId===''">,《<span style="color:blue;cursor : pointer;" @click="showAgreementMessageProtection">{{ $t('protaRegister.messageProtection') }}</span>》,</span>
      <span v-show="this.tenantId===1||this.tenantId===''">《<span style="color:blue;cursor : pointer;" @click="showAgreementOutLands">{{ $t('protaRegister.agreementSecond') }}</span>》</span>

    </span>

      <div slot="footer" class="dialog-footer">

         <el-button type="info" @click="noPass" class="disagree">不同意</el-button>
         <el-button type="primary" @click="addlogin">同意并登录</el-button>
      </div>
    </el-dialog>
  <!-- 弹窗, 用户协议 -->
         <Agreement v-if="agreementVisible"
               ref="agreement"></Agreement>
          <AgreementOutLands v-if="agreementVisibleOutLands"
               ref="agreementOutLands"></AgreementOutLands>
               <AgreementMessageProtection v-if="agreementVisibleMessageProtection" ref="agreementMessageProtection">

               </AgreementMessageProtection>
<!-- 撤销隐私协议 -->
          <revokeCheck v-if="revokeCheckVisible"
                 @refreshRevokeCheck="refreshRevokeCheck"
                 ref="revokeCheck"></revokeCheck>


  </div>
</template>

<script>
// import $ from 'jquery'
// import 'echarts/lib/chart/bar'
// import steps from '../../components/setStep/steps.js'
import RevokeCheck from './revoke-check'
import Agreement from './agree-policy';
import AgreementMessageProtection from './agree-policy-message-protection';
import AgreementOutLands from './agree-policy-outlands';
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import $ from "jquery";
// import axios from 'axios'

export default {
  components: {
    RevokeCheck,
    Agreement,
    swiper,
    swiperSlide,
    AgreementMessageProtection,
    AgreementOutLands

  },
  data() {
    let _this = this;
    return {
      tenantId:"",
      isDefined: false,
      agreementVisibleOutLands:false,
      agreementVisibleMessageProtection:false,
      agreementVisible:false,
      agreement:true,
      agreementOutLands:true,
      revokeCheckVisible:false,
      centerDialogVisible:true, //是否弹协议弹窗
      trainingRecordOptions: {},
      roleVal: false,
      holidayShow: false,
      // 主banner条设置
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
      },
      // 新闻滚动设置
      swiperNewsOption: {
        pagination: {
          el: ".swiper-news-pagination",
          clickable: true,
        },
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // loop: true,
        on: {
          // 每次滑动后，新闻跟着切换
          slideChangeTransitionEnd: function () {
            _this.swiperNewItem = _this.swiperNews[this.activeIndex];
          },
        },
      },
      // 假的banner资讯
      swiperSlides: [],
      // 假的新闻资讯
      swiperNews: [
        // {
        //   img: require('../../assets/img/main1.png'),
        //   title1: '2019年，你还有一件待办事项',
        //   title2: 'BMW卓悦客户体验正式启幕',
        //   txt: '伴随着未来新零售形式和体验消费所带动的汽车行业，深度变革提升客户体验已成为市场竞争的核心和业务可持续性增长的关键，作为豪华品牌的领军者…'
        // },
        // {
        //   img: require('../../assets/img/main1.png'),
        //   title1: '2020年，你还有二件待办事项',
        //   title2: 'BMW卓悦客户体验正式启幕',
        //   txt: '伴随着未来新零售形式和体验消费所带动的汽车行业，深度变革提升客户体验已成为市场竞争的核心和业务可持续性增长的关键，作为豪华品牌的领军者…'
        // }
      ],
      // 切换后的新闻信息
      swiperNewItem: {
        img: "",
        title1: "",
        title2: "",
        txt: "",
      },
      // 假的热门新闻
      swiperHots: [
        {
          img: require("../../assets/img/main4.png"),
          title: "《全新BMW X3全新设计》",
          count: 500,
        },
        {
          img: require("../../assets/img/main5.png"),
          title: "《全新BMW X3升级内饰》",
          count: 350,
        },
        {
          img: require("../../assets/img/main6.png"),
          title: "《全新BMW X3最新互联》",
          count: 327,
        },
        {
          img: require("../../assets/img/main7.png"),
          title: "《全新BMW X3智能安全》",
          count: 230,
        },
        {
          img: require("../../assets/img/main5.png"),
          title: "《全新BMW X3升级内饰》",
          count: 230,
        },
      ],
      schoolWord: null,
      urlHead: "",
      // gifUrl: ''
    };
  },
  computed: {},
  created() {
     // 获取账号类别
    if(this.getStorage(this.GLOBAL.TENANT_ID)){
     this.tenantId= this.getStorage(this.GLOBAL.TENANT_ID);
     }
     console.log(this.tenantId,"tenantId");
    if(this.getStorage(this.GLOBAL.DIALOG_VISIBLE_CENTER)){
      this.centerDialogVisible= false;
    }
    // this.setStorage(this.GLOBAL.DIALOG_VISIBLE,this.isDefined)

    this.swiperNewItem = this.swiperNews[0];

    this.$request.get("/auth/oauthToken").then((res, total, code, data) => {
      if (code == 1) {
        let tokenVal = data.data.oauth_token;
        console.log(tokenVal);
        sessionStorage.setItem("oauth_token", tokenVal);
      }
    });




    // 自动超时退出
    clearInterval(this.timeoutLogoutHandler);
    this.timeoutLogout();
  },
  mounted() {

    var oauth2div = document.getElementById("oauth2js");
    var jqueryJs = document.createElement("script");
    jqueryJs.type = "text/javascript";
    jqueryJs.src = "./js/jquery-3.4.1.min.js";
    oauth2div.appendChild(jqueryJs);

    var oauthJs = document.createElement("script");
    oauthJs.type = "text/javascript";
    oauthJs.src = "./js/oauth2.js";
    oauth2div.appendChild(oauthJs);

    // this.getHolidayNews()
    this.init();
    var userData = this.getStorage(this.GLOBAL.USER_DATA);

    console.log(userData,"userdata=========================")
    this.roleVal = false;
    // 如果TA及TA以上
    if (
      userData &&
      (userData.roleTypeVal === "2" || userData.roleTypeVal === "4") &&
      userData.orgType === "60"
    ) {
      this.roleVal = true;
    }
    // 如果管理员或管理层
    // if (userData && (userData.authType === '10' || userData.authType === '40')) {
    //   this.roleVal = true
    // }

    var userData = this.getStorage(this.GLOBAL.USER_DATA);

    let token = sessionStorage.getItem("v1token");
    token = token.replace(/\"/g, "");
    $("#oauth_form").prop("action", window.SITE_CONFIG["oauthURL"]);
    $("#oauth_username").val("PeppaTokenUser");
    $("#oauth_password").val(token);

    $("#oauth_form").submit();

    let debug = true;
    let tokenUrl = window.SITE_CONFIG["joylearningAdminURL"];
    if (debug) {
      let location = window.location.href;
      if (location.indexOf("https://testjoylearning.bmw.com.cn/#") != -1) {
        tokenUrl = tokenUrl.replace("com.cn:444", "com.cn:9700");
      } else if (location.indexOf("https://testjoylearning.bmw.com.cn/uat-3") != -1) {
        tokenUrl = tokenUrl.replace("com.cn:444", "com.cn:4002");
      } else if (location.indexOf("https://jl-uat.meetfate.cn/test") != -1) {
        tokenUrl = tokenUrl.replace("meetfate.cn:9700", "meetfate.cn:444");
      }
    }

    window.SITE_CONFIG["AdminURL"] = tokenUrl
    tokenUrl = tokenUrl + "/main?menu_url=/page/resource/classifyList";
    console.log(tokenUrl)
    document.getElementById("loginAdminToken").value = window.SITE_CONFIG['userData'].accessToken;
    document.getElementById("adminLoginForm").action = tokenUrl;
    document.getElementById("adminLoginForm").submit();
  },
  methods: {
    addlogin(){
      this.centerDialogVisible=false;
      this.setStorage(this.GLOBAL.DIALOG_VISIBLE_CENTER,true)
      this.isDefined=true;
      this.setStorage(this.GLOBAL.DIALOG_VISIBLE,false)
      this.refreshPage()
    },
    noPass(){
      if(this.tenantId && this.tenantId!=1){
        if(!this.isDefined ){
         this.setStorage(this.GLOBAL.DIALOG_VISIBLE,true)
          if (navigator.userAgent.indexOf("MSIE") > 0) {
                if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
                    window.opener = null;
                    window.close();
                } else {
                    window.open('', '_top');
                    window.top.close();
                }
            }
            else if (navigator.userAgent.indexOf("Firefox") > 0 || navigator.userAgent.indexOf("Chrome") > 0) {
                //window.location.href = 'about:blank ';
                window.location.href = "about:blank";
                window.close();
            }
            else {
                window.opener = null;
                window.open('', '_self');
                window.close();
            }

      }
      }else{
        if(!this.isDefined){
          this.setStorage(this.GLOBAL.DIALOG_VISIBLE,true)
          this.$router.push({
            name: 'protalMain'
          })
        }
      }
    },
    // 隐私协议弹窗
    showAgreement() {
      this.agreementVisible = true
      console.log(this.$refs.agreement,"this.$refs.agreement***************************")
      this.$nextTick(() => {
        this.$refs.agreement.init()
      })
    },
    showAgreementOutLands(){
      this.agreementVisibleOutLands = true
      this.$nextTick(() => {
        this.$refs.agreementOutLands.init()
      })
    },
    showAgreementMessageProtection(){
      this.agreementVisibleMessageProtection = true
      this.$nextTick(() => {
        this.$refs.agreementMessageProtection.init()
      })
    },
    /**
     * 测试文章1，了解详情
     */
    learnMore1(url) {
      window.open(url);
      // this.$router.push({
      //   name: 'news-detail-main',
      //   query: {
      //     newsId: url
      //   }
      // })
    },
    goDetail(id) {
      this.$router.push({
        name: "news-detail",
        query: {
          newsId: id,
        },
      });
    },
    // 查看更多
    showMore() {
      this.$router.push({
        name: "information",
      });
    },
    /**
     * 切换swiper的状态回调
     * @param {*} event 切换后的元素
     */
    callback(event) {},
    init() {
      this.$request
        .get("/common/recommend/FirstPagesAfterLogin")
        .then((res, total, code, data) => {
          console.log(res);
          this.swiperSlides = res;
        })
        .catch(() => {});

      // 初始化echarts
      this.trainingRecordOptions = {
        color: ["#1C69D3", "#006699", "#4cabce", "#e5323e"],
        title: {
          text: "某地区蒸发量和降水量",
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: [
          {
            type: "category",
            data: [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "课时",
            barWidth: 20,
            data: [12, 11, 35, 15, 25, 29, 11, 12, 38],
            type: "bar",
          },
        ],
      };

      // 初始化流程图
      /* eslint-disable */
      // steps({
      //   el: "#steps1",
      //   data: [
      //     { title: "2009年七月", description: "入职xx经销商" },
      //     { title: "2009年七月", description: "入职xx经销商" },
      //     { title: "2009年七月", description: "入职xx经销商" }
      //   ],
      //   center: true,
      //   iconType: "bullets",
      //   active: 2
      // })
      console.log(this.getStorage("html5List"));
      this.schoolWord = this.getStorage("html5List")[7];
      // if (this.schoolWord.paramValue) {
      //   var index = this.schoolWord.paramValue.lastIndexOf('/')
      //   this.urlHead = this.schoolWord.paramValue.substring(0,index)
      //   console.log(this.urlHead)
      // }
      this.$request
        .get("/sys/commcontent/list", {
          contentPubStatus: "10",
          contentColumn: "60",
          orderBy: "1",
          page: 1,
          limit: 6,
        })
        .then((res, total, code, data) => {
          console.log(res);
          let newArray = [];
          if (res.records.length < 4) {
            let banner = {};
            res.records.forEach((element, index) => {
              element["index"] = "0" + (index + 1);
            });
            banner["banner"] = res.records;
            newArray.push(banner);
          } else {
            let banner = {};
            banner["banner"] = [];
            res.records[0]["index"] = "01";
            res.records[1]["index"] = "02";
            res.records[2]["index"] = "03";
            banner.banner.push(res.records[0]);
            banner.banner.push(res.records[1]);
            banner.banner.push(res.records[2]);
            newArray.push(banner);
            let banner1 = {};
            banner1["banner"] = [];
            for (var i = 3; i < res.records.length; i++) {
              res.records[i]["index"] = "0" + (i + 1);
              banner1.banner.push(res.records[i]);
            }
            newArray.push(banner1);
          }
          this.swiperNews = newArray;
        })
        .catch(() => {});
    },
    refreshPage() {
      if (location.href.indexOf("#reloaded") == -1) {
        location.href = location.href + "#reloaded";
        location.reload();
      }
    },
    // // 获取节假日庆祝动画
    // getHolidayNews() {
    //   const userCode = JSON.parse(sessionStorage.getItem('v1user_data')).userCode
    //   if(sessionStorage.getItem('holiday')===null){
    //     this.$request.post('/sys/common/listPopsUp', { userCode: userCode }
    //     ).then((res) => {
    //       if(res){
    //         const arr = res.indexPopUpsVOList
    //         for(let i=0;i<arr.length;i++){
    //           if(arr[i].title.indexOf('新春快乐')>=0||arr[i].title.indexOf('新年')>=0){
    //             this.gifUrl = arr[i].img
    //             this.holidayShow = true
    //             sessionStorage.setItem('holiday', true)
    //             break;
    //           }
    //         }
    //       }
    //     }).catch(() => { })
    //   }
    // },
    // closeHolidayPop() {
    //   this.holidayShow = false
    //   sessionStorage.setItem('holiday', false)
    // }
  },
};
</script>
<style lang="scss" scoped>
// @import "../../components/setStep/steps.css";
/deep/ .el-dialog__footer {
  padding: 0px !important;
}

.el-dialog--center .el-dialog__footer {
    display: -webkit-box;
    display: flex;
    padding: 25px 0px 0px 0px !important;
}
.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.el-dialog__title{
    color:black;
}
.el-dialog__footer{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 25px 0px 0px 0px !important;
}
.el-dialog--center .el-dialog__footer button:nth-child(1) {
    margin: 0px !important;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    background-color: #434343;
    color: #fff;
    border: 0px;
    line-height: 25px;
    min-width: 225px;
}
.el-dialog--center .el-dialog__footer button:nth-child(2) {
    margin-left: 0px !important;
    float: right !important;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    line-height: 23px;
    min-width: 225px;
}
.main-news {
  overflow: hidden;
  // height: 400px;
  width: 1200px;
  margin: 0 auto;
  margin-top: 70px;
  margin-bottom: 40px;
  .news-title {
    font-size: 18px;
    // font-weight: bold;
    border-bottom: 2px solid #999;
    padding-bottom: 10px;
    position: relative;
    .news-more {
      position: absolute;
      right: 0;
      font-size: 14px;
      cursor: pointer;
      color: #aaa;
    }
  }
  .news-swiper {
    height: 280px;
    .news-overflow {
      cursor: pointer;
      overflow: hidden;
      border-bottom: 1px solid #aaa;
      display: flex;
      padding: 10px;
      align-items: center;
      .news-index {
        width: 100px;
        font-size: 25px;
        font-weight: bold;
        color: #333;
      }
      .news-desc {
        width: 1100px;
        font-size: 16px;
        line-height: 26px;
      }
    }
    .swiper-container {
      height: 280px;
    }
  }
  .news-content {
    float: left;
    height: 260px;
    margin-left: 50px;
    .news-content-title {
      font-size: 36px;
      color: #000000;
      letter-spacing: 0.32px;
      line-height: 60px;
    }
    .news-content-txt {
      font-size: 18px;
      color: #000000;
      letter-spacing: 0.29px;
      line-height: 40px;
      margin-top: 40px;
      margin-bottom: 30px;
    }
    .news-content-btn {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #666666;
      color: #fff;
      font-size: 16px;
      width: 190px;
      height: 50px;
    }
  }
}
.main-small-news {
  overflow: hidden;
  height: 145px;
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
  .main-small-news-left {
    float: left;
    width: 600px;
    .main-small-img {
      float: left;
      width: 220px;
      img {
        width: 220px;
        height: 145px;
      }
    }
    .main-small-content {
      float: left;
      width: 310px;
      margin-left: 20px;
      .news-content-title {
        font-size: 18px;
        color: #000000;
        letter-spacing: 0.29px;
      }
      .news-content-txt {
        margin-top: 20px;
        margin-bottom: 15px;

        font-size: 14px;
        color: #000000;
        letter-spacing: 0.25px;
        line-height: 30px;
      }
      .news-content-btn {
        cursor: pointer;

        font-size: 14px;
        color: #000000;
        letter-spacing: 0.25px;
        line-height: 30px;
      }
    }
  }
  .person-content {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    margin-bottom: 20px;

    .content-left {
      width: 468px;
      background: #fff;
      border-radius: 4px;
      .big-title {
        margin-top: 40px;
        margin-left: 30px;
        font-size: 30px;
        color: #fff;
        font-weight: bold;
      }
      .big-small {
        margin-top: 18px;
        margin-left: 30px;
        font-size: 16px;
        color: #fff;
      }
      .big-small.first {
        margin-top: 34px;
      }
      .training-record {
        .chart1 {
          width: 420px;
          height: 260px;
          margin-left: 30px;
        }
        .title-div {
          overflow: hidden;
          padding: 20px 20px 0 45px;
          .title-left {
            float: left;
          }
          .title-right {
            float: right;
            cursor: pointer;
            font-size: 12px;
            svg {
              color: #1c69d3;
              font-size: 18px;
              vertical-align: text-bottom;
            }
          }
        }
      }
    }
    .content-right {
      width: 712px;
      background: #fff;
      border-radius: 4px;
      .todo-title {
        margin: 20px 0 0 30px;
        font-size: 20px;
      }
      .todo-content {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        .each-btn {
          text-align: center;
          width: 178px;
          cursor: pointer;
          .count {
            font-size: 40px;
          }
          .each-txt {
            margin-top: 20px;
          }
        }
      }
      .training-record {
        font-size: 16px;
        margin: 20px 20px 40px 30px;
      }
      #steps1 {
        margin-top: 100px;
        .step-description {
          color: #303133;
        }
      }
    }
    .content-left.bule {
      background: #1c69d3;
    }
    .content-small {
      width: 224px;
      background: #fff;
      border-radius: 4px;
      .study-div {
        text-align: center;
        svg {
          font-size: 56px;
          color: #1c69d3;
        }
        .study-svg {
          height: 56px;
          margin: 40px 0 30px;
        }
        .study-title {
          font-size: 22px;
        }
      }
    }
    .height-200 {
      height: 200px;
    }
    .height-230 {
      height: 230px;
    }
    .height-300 {
      height: 300px;
    }
  }
}
.protal-content-title {
  margin: 16px 0;
  width: 100%;
  font-weight: bold;
  color: #333;
  font-size: 16px;
}
.swiper-container {
  height: 520px;
}
.swiper-slide {
  height: 560px;
}
.swiper-scrollbar {
  position: relative;
  width: 1200px;
  background: none;
  margin: 0 auto;
  bottom: 28px;
}
.swiper-pagination {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  bottom: 10px;
  display: flex;
  justify-content: center;
  .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 4px;
  }
  .swiper-pagination-bullet {
    width: 40px;
    border-radius: 0;
    height: 4px;
  }
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: #262626;
  }
}
.swiper-news-pagination {
  position: relative;
  width: 600px;
  margin: 0 auto;
  bottom: 10px;
  display: flex;
  justify-content: center;
  .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 4px;
  }
  .swiper-pagination-bullet {
    width: 20px;
    border-radius: 0;
    height: 4px;
  }
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: #5c5c5c;
  }
}
.news-label {
  margin-top: 40px;
  // font-weight: bold;
  font-size: 18px;
  display: flex;
}
.news-label-block {
  display: inline-block;
  width: 10px;
  height: 30px;
  background: #000;
  margin-right: 15px;
}
.dash-div {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
.dash-float img {
  // width: 220px;
  width: 90%;
  // height: 164px;
}
.banner-view {
  .each-banner {
    height: 560px;
    background-repeat: no-repeat;
    background-position: center;
    .banner-middle {
      width: 100%;
      margin: 0 auto;
      position: relative;
      height: 500px;
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: center;
      .banner-content-middle {
        position: relative;
        width: 1200px;
        margin: 0 auto;
      }
      .banner-content {
        position: absolute;
        top: 320px;
        left: 50px;
        text-align: left;
        .banner-title {
          line-height: 49px;

          font-size: 35px;
          color: #262626;
          letter-spacing: -0.35px;
        }
        .banner-txt {
          font-size: 20px;
          color: #262626;
          letter-spacing: -0.2px;
          line-height: 29px;
          margin-top: 32px;
        }
        .banner-btn {
          float: right;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 32px;
          background: #1c69d49e;
          width: 212px;
          height: 52.5px;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0.26px;
        }
      }
    }
  }
}
.html5-div {
  width: 1200px;
  margin: 0 auto;
  margin-top: 70px;
  min-height: 300px;
  // background: #f8f8f8;
  // border: 1px solid #cccccc;
  box-sizing: border-box;
  .html5-content {
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 30px;
    color: #333333;
    height: 500px;
  }
  .html5-content1 {
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 30px;
    color: #333333;
    height: 250px;
  }
  .html5-content2 {
    float: left;
    width: 600px;
    text-align: center;

    font-size: 30px;
    color: #333333;
    height: 250px;
  }
}
.bmw-float-btn {
  position: fixed;
  width: 108px;
  height: auto;
  bottom: 2em;
  right: 0;
}
.box-btns {
  position: relative;
  width: 120px;
  height: 80px;
  margin: 30px 0;
  z-index: 99999999999999;
}
.table-box {
  border: none;
  width: 40px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 30px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.5);
}
.circle-box {
  width: 80px;
  height: 80px;
  border: none;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  right: 27px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.5);
}
.circle-box > a {
  text-decoration: none;
}
.circle-text {
  width: 40px;
  height: 40px;
  line-height: 20px;
  border: none;
  border-radius: 50%;
  margin: 8px;
  padding: 12px;
  background-color: #fff;
  color: #000;
  font-size: 1em;
  text-align: center;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5) inset;
  cursor: pointer;
  box-sizing: content-box;
}
.circle-text.mouse-down {
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
}
.dialog-footer {
  .el-button {
    border-radius: 0px !important;
  }
}
</style>
